export const initAssets = [
  'brand/anim/skeleton.json',
  'atlases/init-0.json',
]
export const splashAssets = [
  'animations/spine/fullscreen/skeleton.json',
  'brand/images/brand.png',
  'atlases/splash-0.json',
  'atlases/base-0.json',
]
export const assets = [
  'animations/spine/back/land/skeleton.json',
  'animations/spine/back/port/skeleton.json',
  'animations/spine/freespins/land/freespin/skeleton.json',
  'animations/spine/freespins/land/fscongrat/skeleton.json',
  'animations/spine/freespins/port/freespin/skeleton.json',
  'animations/spine/freespins/port/fscongrat/skeleton.json',
  'animations/spine/items/win/1/skeleton.json',
  'animations/spine/items/win/2/skeleton.json',
  'animations/spine/items/win/A/skeleton.json',
  'animations/spine/items/win/B/skeleton.json',
  'animations/spine/items/win/C/skeleton.json',
  'animations/spine/items/win/D/skeleton.json',
  'animations/spine/items/win/E/skeleton.json',
  'animations/spine/items/win/F/skeleton.json',
  'animations/spine/items/win/G/skeleton.json',
  'animations/spine/items/win/H/skeleton.json',
  'animations/spine/items/win/I/skeleton.json',
  'animations/spine/items/win/J/skeleton.json',
  'animations/spine/lines/skeleton.json',
  'animations/spine/reels/chance/skeleton.json',
  'animations/spine/win/big/skeleton.json',
  'animations/spine/win/mega/skeleton.json',
  'animations/spine/win/ultra/skeleton.json',
  'bitmap/bitmap.xml',
  'atlases/main-0.json',
]
export const particle = []
